module.exports = __webpack_public_path__ + "img/banner_h501.cf92c608.webp";